import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $data: EquipmentCreateInput!
  ) {
    createOneEquipment(data: $data) {
      name
    }
  }
`

export default () => (
  useMutation(MUTATION, `Equipamento criado`, mutationTypes.CREATE)
)
